// Copyright (c) 2025 ParkEngage Inc. All rights reserved.

// This software is the confidential and proprietary information of
// ParkEngage Inc. ("Confidential Information"). You shall not
// disclose such Confidential Information and shall use it only in
// accordance with the terms of the license agreement you entered into
// with ParkEngage Inc.

// This source code is a valuable trade secret of ParkEngage Inc.

// THIS SOFTWARE IS PROVIDED BY ParkEngage Inc. ``AS IS'' AND ANY
// EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
// PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL [YOUR COMPANY NAME] OR
// CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
// EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
// PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
// PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY
// OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.

// The views and conclusions contained in the software and documentation
// are those of the authors and should not be interpreted as representing
// official policies, either expressed or implied, of ParkEngage Inc.

import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
//import { CLIENT_SECRET, EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
// import { EMPTY_ARRAY, EMPTY_OBJECT, EXPIRY_MONTHS, EXPIRY_YEARS } from '../../../constants/globalConstants' //, 
import { EMPTY_ARRAY, EMPTY_OBJECT, PAYMENT_GATEWAY, usesHostedCardFields } from '../../../constants/globalConstants' //,
import PaymentGatewayCommon from '../../paymentForm/PaymentGatewayCommon'


import { prorateList } from '../../../redux/actions/paymentActions'
import { MaskedInput, createDefaultMaskGenerator } from 'react-hook-mask'
import { Circles } from 'react-loader-spinner'
import { isLoggedIn, isPermissionExist, perkingParkingTime, phoneMasker, restrictInputValues, restrictSpecialChar, sortPortalPermissionByKey, validateCardNumber, validExpiryDate, shouldShowVehicleColumn } from '../../../utils/helper'
import moment from 'moment'
import { getCardDataList } from '../../../redux/actions/cardDetailsAction'
import { getConfigDetails } from '../../../services/config'
// import ModalTerm from './termCond'
import ModalTerm from '../../responsiveReservation/termCond'
import useMobileView from '../../../Hooks/useMobileView'
import CardConnectTokenizer from '../../../components/walletButtons/CardConnectTokenizer'
const cardnumbermask = createDefaultMaskGenerator('9999 9999 9999 9999')
const expirymask = createDefaultMaskGenerator('99/99')

function Pass(props) {
    const { notify, guidValue, resValue, setPage, idProof, rateList, dispatch, paymentLoader, formData, setFormData, formError, partnerDetails, selectedVehicleList,
        setCardToken, setIframeErrorMsg, tokenRef, onCardSubmit, isSubmitting, setHostedCardShown } = props

    const [images, setImages] = useState(EMPTY_OBJECT)
    // const [formData, setFormData] = useState()
    const [facility, setFacility] = useState(EMPTY_OBJECT)
    const [prorateResponse, setProrateResponse] = useState(EMPTY_OBJECT)
    const [refractedVehicleList, setRefractedVehicleList] = useState(EMPTY_ARRAY)
    const [card, setCard] = useState()
    const [couponError, setCouponError] = useState('')
    const [coupon, setCoupon] = useState('')
    const [expiry, setExpiry] = useState()
    //const [phone, setPhone] = useState('')
    // const [name, setName] = useState('')
    // const [email, setEmail] = useState('')
    //const [cvv, setCvv] = useState('')
    // const [expiryMonth, setExpiryMonth] = useState('')
    // const [expiryYear, setExpiryYear] = useState('')
    const [couponRemoveButton, setCouponRemoveButton] = useState()
    const [isCouponApplied, setIsCouponApplied] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isCardFormVisible, setCardFormVisible] = useState(false)
    const [cardList, setCardList] = useState(EMPTY_ARRAY)
    const [accessPermissions, setAccessPermissions] = useState('')
    // const [loginData, setLoginData] = useState(EMPTY_OBJECT)
    const [isConsent, setIsConsent] = useState(true)
    const [selectedPermit, setSelectedPermit] = useState(EMPTY_ARRAY)
    const [showTerm, setTermShow] = useState(false)
    const [displayVehicle, setDisplayVehicle] = useState(false)
    // to handle the vehicle for menlo
    const allHaveMst_model = localStorage.getItem('allHaveMst_model') ? JSON.parse(localStorage.getItem('allHaveMst_model')) : true
    const isMobile = useMobileView()

    // New card in the gateway's hosted fields (Stripe, Datacap / Heartland iframe): Main hides its Submit then
    const showsHostedCardFields = (cardList?.length < 1 || isCardFormVisible) && usesHostedCardFields(facility)
    useEffect(() => {
        if (setHostedCardShown) setHostedCardShown(showsHostedCardFields)
    }, [showsHostedCardFields])

    useEffect(() => {
        if (Number(formData?.permit_final_amount) <= 0) {
            setIsConsent(false)
            formData['userConsent'] = false
            setFormData({ ...formData })
        } else {
            setIsConsent(true)
            formData['userConsent'] = true
            setFormData({ ...formData })
        }
    }, [EMPTY_ARRAY, formData?.permit_final_amount])

    useEffect(() => {
        const getAccessPermissionData = sortPortalPermissionByKey(partnerDetails, 'Restricted Permissions')
        setAccessPermissions(getAccessPermissionData)
    }, [EMPTY_ARRAY, partnerDetails])

    useEffect(() => {
        // setPhone('')
        localStorage.setItem('name', '')
        localStorage.setItem('email', '')
        localStorage.setItem('phone', '')
        localStorage.setItem('card_date_expiry_month', '')
        localStorage.setItem('card_date_expiry_year', '')
        localStorage.setItem('card_pan', '')
        localStorage.setItem('CardNumberLast4', '')
        localStorage.setItem('expiration_date', '')

        const signupFormData = JSON.parse(localStorage.getItem('userData'))
        const consent = (signupFormData && signupFormData?.user && signupFormData?.user?.user_consent && signupFormData?.user?.user_consent == '0') ? false : Number(formData?.permit_final_amount) <= 0 ? false : true
        setIsConsent(consent)
        formData['userConsent'] = consent
        setFormData({ ...formData })
        const facility = JSON.parse(localStorage.getItem('facility'))
        const permits = JSON.parse(localStorage.getItem('permits'))
        setSelectedPermit(permits)
        let finalVehicleList = []
        selectedVehicleList?.map((value) => {
            if (value?.license_plate) {
                finalVehicleList.push({
                    'license_plate': value?.license_plate,
                    'make': value?.othermake ? value?.maketext : value?.make,
                    'model': value?.othermodel ? value?.modeltext : value?.model,
                    'color': value?.color,
                    'style': value?.style,
                    'state_id': value?.state_id,
                    'state_code': value?.state_code,
                    'vehicle_type': value?.vehicle_type ?? '',
                    'vehcle_type_id': value?.vehicle_type_id ?? '',
                    'vehicle_number': value?.vehicle_number ?? ''
                })
            }
        })
        setRefractedVehicleList(finalVehicleList)

        const payLoadData = {
            facility_id: facility?.id,
            driving_license: formData?.license_number,
            // permit_rate_id: permits?.id
            permit_rate_id: permits?.id ? permits?.id : formData?.permit_rate_id,
        }
        dispatch(prorateList(payLoadData)).then((res) => {
            setIsLoading(false)
            setIsCouponApplied(false)
            formData['permit_rate'] = res?.data?.total_amount
            formData['coupon_applied'] = false
            formData['is_guest'] = isLoggedIn() ? '0' : '1'
            formData['processing_fee'] = res?.data?.processing_fee
            setFormData({ ...formData })
            setProrateResponse(res?.data)
        })

        if (isLoggedIn()) {
            setCardFormVisible(false)
            // const facility_id = partnerDetails?.facilities?.[0]?.id
            dispatch(getCardDataList()).then((res) => {
                if (res?.data) {
                    setCardList(res?.data?.payments)
                    setIsLoading(false)
                }
            }).catch(() => {
                setIsLoading(false)
            })
        } else {
            setCardFormVisible(true)
        }
    }, [EMPTY_ARRAY])

    // const handleInputChange = (e) => {
    // 	const {name, value} = e.target

    // 	if(name == 'card_date_expiry_month'){
    // 		setExpiryMonth(value)
    // 	}
    // 	if(name == 'card_date_expiry_year'){
    // 		setExpiryYear(value)
    // 	}

    // 	localStorage.setItem([name], value.trim())

    // }

    const handleCardChange = (value) => {
        setCard(value?.trim())
        formData['card_pan'] = value?.trim()
        if (value) {
            localStorage.setItem('CardNumberLast4', value?.trim()?.slice(-4))
        }
        setFormData({ ...formData })
    }
    // const handleExpiryChange = (value) => {
    // 	setExpiry(value?.trim())
    //     formData['expiration_date'] = value?.trim()
    // 	setFormData({...formData})
    // }

    const handleCardSelectChange = (e) => {
        const { value } = e.target
        const selectedCard = cardList?.filter((card) => card?.payment_profile_id == value)
        if (selectedCard.length == 1) {
            localStorage.setItem('CardNumberLast4', JSON.stringify(selectedCard[0]?.card_last_four))
            localStorage.setItem('expiration_date', JSON.stringify(selectedCard[0].expiry))
            localStorage.setItem('card_type', JSON.stringify(selectedCard[0].card_type))
        }
        setFormData({ ...formData, ['payment_profile_id']: selectedCard[0]?.payment_profile_id })

    }

    const handleAcknowledge = (e) => {
        const { name, checked } = e.target
        setFormData({ ...formData, [name]: checked })
    }

    const showCardForm = () => {
        setCardFormVisible(true)
        setFormData({ ...formData, ['payment_profile_id']: '' })
    }

    const hideCardForm = () => {
        setCardFormVisible(false)
        setFormData({ ...formData, ['payment_profile_id']: '' })
    }

    useEffect(() => {
        setPage('pass')

        const facility = JSON.parse(localStorage.getItem('facility'))
        setFacility(facility)
        if (idProof?.front || idProof?.back) {
            const front = idProof?.front ? URL.createObjectURL(idProof?.front) : ''
            const back = idProof?.back ? URL.createObjectURL(idProof?.back) : ''

            setImages({ ...images, front: front, back: back })
        }

        const selectedPermit = rateList?.filter((item) => item?.id == Number(formData?.permit_type))
        if (selectedPermit?.permit_rate?.length > 0) {
            const selRate = selectedPermit?.permit_rate?.filter((item) => item?.id === formData?.permit_rate_id)
            formData['permit_rate'] = selRate[0]?.rate
            formData['permit_rate_id'] = selRate[0]?.id

            setFormData({ ...formData })
        }

        delete formData.name
        delete formData.card_pan
        delete formData.card_date_expiry_month
        delete formData.card_date_expiry_year
        delete formData.card_card_security_cvx_2
        delete formData.zip_code
        delete formData.expiration_date

    }, [EMPTY_ARRAY])

    const handleInputFieldsData = (e, i, perItem) => {
        const { name, value } = e.target
        if (name == 'permit_rate') {
            formData['permit_rate'] = perItem?.rate
            formData['permit_rate_id'] = perItem?.id
            setFormData({ ...formData })
            setFormData({ ...formData, ['permit_rate']: value })
            const facility = JSON.parse(localStorage.getItem('facility'))
            const proRatePayload = {
                facility_id: facility?.id,
                driving_license: formData?.license_number,
                permit_rate_id: perItem?.id
            }
            dispatch(prorateList(proRatePayload)).then((res) => {
                setIsCouponApplied(false)
                formData['permit_rate'] = perItem?.rate
                formData['permit_rate_id'] = perItem?.id
                formData['coupon_applied'] = false
                formData['processing_fee'] = res?.data?.processing_fee
                setFormData({ ...formData })
                setProrateResponse(res?.data)
            })
        } else if (name == 'promocode') {
            setCoupon(value)
        }
        setFormData({ ...formData, [name]: value })
    }
    // const handlePhoneChange = (value) => {
    // 	setPhone(value.trim())
    // 	localStorage.setItem('phone', value.trim())
    // }
    const handleConsentChange = (e) => {
        const { name, checked } = e.target
        setIsConsent(!isConsent)
        setFormData({ ...formData, [name]: checked })
    }
    const handleCouponRemove = () => {
        setCouponError('')
        setCoupon('')
        setCouponRemoveButton(false)
        const facility = JSON.parse(localStorage.getItem('facility'))
        const permits = JSON.parse(localStorage.getItem('permits'))

        const payLoadData = {
            is_guest: isLoggedIn() ? '0' : '1',
            facility_id: facility?.id,
            driving_license: formData?.license_number,
            // permit_rate_id: permits?.id
            permit_rate_id: permits?.id ? permits?.id : formData?.permit_rate_id,
        }
        dispatch(prorateList(payLoadData)).then((res) => {
            setCouponError('')
            setIsCouponApplied(false)
            setProrateResponse(res?.data)
            formData['permit_rate'] = res?.data?.total_amount
            formData['coupon_applied'] = false
            formData['promocode'] = ''
            formData['is_guest'] = isLoggedIn() ? '0' : '1'
            formData['processing_fee'] = res?.data?.processing_fee
            setFormData({ ...formData })
        })
    }

    const handleCouponCode = () => {
        if (coupon?.trim()) {
            setCouponRemoveButton(true)
            setCouponError('')
            setIsLoading(true)
            setIsCouponApplied(true)
            setCoupon(coupon)
            const facility = JSON.parse(localStorage.getItem('facility'))
            const permits = JSON.parse(localStorage.getItem('permits'))
            const proRate = {
                is_guest: isLoggedIn() ? '0' : '1',
                facility_id: facility?.id,
                driving_license: formData?.license_number,
                permit_rate_id: permits?.id,
                promocode: coupon,
                client_id: getConfigDetails()?.CLIENT_SECRET,
                email: formData?.email,
                phone: formData?.phone,
                license_plate: refractedVehicleList?.[0]?.license_plate,
            }
            dispatch(prorateList(proRate)).then((res) => {
                if (res?.data) {
                    setIsLoading(false)
                    setIsCouponApplied(true)
                    formData['permit_rate'] = res?.data?.total_amount
                    formData['coupon_applied'] = true
                    formData['processing_fee'] = res?.data?.processing_fee
                    setFormData({ ...formData })
                    setProrateResponse(res?.data)
                } else {
                    setIsLoading(false)
                    setCouponError(res?.errors?.message)
                    const facility = JSON.parse(localStorage.getItem('facility'))
                    const permits = JSON.parse(localStorage.getItem('permits'))

                    const payLoadData = {
                        facility_id: facility?.id,
                        driving_license: formData?.license_number,
                        // permit_rate_id: permits?.id
                        permit_rate_id: permits?.id ? permits?.id : formData?.permit_rate_id,
                    }
                    dispatch(prorateList(payLoadData)).then((res) => {
                        setIsCouponApplied(false)
                        formData['permit_rate'] = res?.data?.total_amount
                        formData['coupon_applied'] = false
                        formData['is_guest'] = isLoggedIn() ? '0' : '1'
                        formData['processing_fee'] = res?.data?.processing_fee
                        setFormData({ ...formData })
                        setProrateResponse(res?.data)
                    })

                }

            }).catch((error) => {
                setCouponError(error?.errors?.message)
                setCoupon('')
                setCouponRemoveButton(false)
                const facility = JSON.parse(localStorage.getItem('facility'))
                const permits = JSON.parse(localStorage.getItem('permits'))

                const payLoadData = {
                    facility_id: facility?.id,
                    driving_license: formData?.license_number,
                    // permit_rate_id: permits?.id
                    permit_rate_id: permits?.id ? permits?.id : formData?.permit_rate_id,
                }
                dispatch(prorateList(payLoadData)).then((res) => {
                    setIsCouponApplied(false)
                    formData['permit_rate'] = res?.data?.total_amount
                    formData['coupon_applied'] = false
                    formData['is_guest'] = isLoggedIn() ? '0' : '1'
                    formData['processing_fee'] = res?.data?.processing_fee
                    setFormData({ ...formData })
                    setProrateResponse(res?.data)
                })
                setIsLoading(false)
                setIsCouponApplied(false)
                formData['coupon_applied'] = false

            })
        } else {
            setCouponError('Please enter a valid promocode')
            setCoupon('')
            setCouponRemoveButton(false)
            const facility = JSON.parse(localStorage.getItem('facility'))
            const permits = JSON.parse(localStorage.getItem('permits'))

            const payLoadData = {
                facility_id: facility?.id,
                driving_license: formData?.license_number,
                // permit_rate_id: permits?.id
                permit_rate_id: permits?.id ? permits?.id : formData?.permit_rate_id,
            }
            dispatch(prorateList(payLoadData)).then((res) => {
                setIsCouponApplied(false)
                formData['permit_rate'] = res?.data?.total_amount
                formData['coupon_applied'] = false
                formData['is_guest'] = isLoggedIn() ? '0' : '1'
                formData['processing_fee'] = res?.data?.processing_fee
                setFormData({ ...formData })
                setProrateResponse(res?.data)
            })
            setIsLoading(false)
            setIsCouponApplied(false)
            formData['coupon_applied'] = false

        }

    }

    const handleModalTerm = () => {
        setTermShow(!showTerm)
    }

    // const handleExpiryChange = (value) => {
    //     setExpiry(value?.trim())
    //     formData['expiration_date'] = value?.trim()
    //     setFormData({...formData})
    // }

    const handleExpiryChange = (value) => {
        //     let expiryDateCheck= value.length == 4  && value.substring(0 , 2) < 13 &&  (value.substring(0 , 2)>=moment(new Date()).format('MM') &&  value.substring(2)>=moment(new Date()).format('YY')
        //    || value.substring(0 , 2)<=moment(new Date()).format('MM') &&  value.substring(2)> moment(new Date()).format('YY')
        // )
        let expiryDateCheck = validExpiryDate(value)
        if (value.length == 4 && !expiryDateCheck) {
            notify('error', 'Please Enter a valid expire date')
            setExpiry('')
            formData['expiration_date'] = ''
            setFormData({ ...formData })
        } else {
            setExpiry(value?.trim())
            formData['expiration_date'] = value?.trim()
            if (expiryDateCheck) {
                localStorage.setItem('expiration_date', value?.trim())
            }
            setFormData({ ...formData })

        }

    }

    const handleshowVehicle = () => {
        setDisplayVehicle(!displayVehicle)
    }

    const DisplayField = (label, value) => {
        return <div className="col-6">
            <label className="floatLabel">{label}</label>
            <div className="inputBox">{value || '-'}</div>
        </div>
    }

    const mobileViewVehicleSection = (vehicleListItem = {}, vehicleListIndex, allVehicle) => {
        return <div key={vehicleListIndex} className="row bg-light g-1 p-1 mt-3">
            {DisplayField('License Plate', vehicleListItem?.license_plate || '-')}
            {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') ? DisplayField('Vehicle Type', vehicleListItem?.vehicle_type || '-') : null}
            {shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? DisplayField('Make/Model', (vehicleListItem.make || vehicleListItem.model)
                ? `${vehicleListItem.make ?? ''}${allHaveMst_model && vehicleListItem.model ? ` / ${vehicleListItem.model}` : ''}`
                : '-' || '-') : null}
            {/* {is_modal_show ? DisplayField('Model', vehicleListItem?.model || '-') : null} */}
            {shouldShowVehicleColumn(allVehicle, 'color') ? DisplayField('Color', vehicleListItem?.color || '-') : null}
            {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') ? DisplayField('Style', vehicleListItem?.style || '-') : null}

            {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') ? DisplayField('Country', vehicleListItem?.country || '-') : null}
            {shouldShowVehicleColumn(allVehicle, 'state_code') ? DisplayField('State', vehicleListItem?.state_code || '-') : null}
            {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') ? DisplayField('VIN', vehicleListItem?.vehicle_number || '-') : null}
        </div>
    }

    const renderVehicleRow = (vehicle = {}, i, allVehicle) => {
        return (
            <tr key={i}>
                <td className="px-0">{vehicle.license_plate || '-'}</td>
                {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(allVehicle, 'vehicle_type') && (
                    <td className="px-0">{vehicle.vehicle_type || '-'}</td>
                )}
                {shouldShowVehicleColumn(allVehicle, 'make') && shouldShowVehicleColumn(allVehicle, 'model') ? <td className="px-0">
                    {(vehicle.make || vehicle.model)
                        ? `${vehicle.make ?? ''}${allHaveMst_model && vehicle.model ? ` / ${vehicle.model}` : ''}`
                        : '-'}
                </td> : null}
                {shouldShowVehicleColumn(allVehicle, 'color') ? <td className="px-0">{vehicle.color || '-'}</td> : null}
                {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(allVehicle, 'style') && (
                    <td className="px-0">{vehicle.style || '-'}</td>
                )}
                {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(allVehicle, 'country') && (
                    <td className="px-0">{vehicle.country || '-'}</td>
                )}
                {shouldShowVehicleColumn(allVehicle, 'state_code') ? <td className="px-0">{vehicle.state_code || '-'}</td> : null}
                {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(allVehicle, 'vehicle_number') && (
                    <td className="px-0">{vehicle.vehicle_number || '-'}</td>
                )}
            </tr>
        )
    }

    const deskTopViewVehicleSection = () => {
        return <div className='table-responsive'>
            <table className="table table-borderless table-sm mb-0">
                <thead>
                    <tr>
                        <th className="fw-bold px-0">License Plate</th>
                        {isPermissionExist(accessPermissions, 'Get Vehicle Type') && shouldShowVehicleColumn(refractedVehicleList, 'vehicle_type') && (
                            <th className="fw-bold px-0">Vehicle Type</th>
                        )}
                        {shouldShowVehicleColumn(refractedVehicleList, 'make') && shouldShowVehicleColumn(refractedVehicleList, 'model') ? <th className="fw-bold px-0">{`Make${allHaveMst_model ? ' / Model' : ''}`}</th> : null}
                        {shouldShowVehicleColumn(refractedVehicleList, 'color') ? <th className="fw-bold px-0">Color</th> : null}
                        {isPermissionExist(accessPermissions, 'Get Vehicle Style') && shouldShowVehicleColumn(refractedVehicleList, 'style') && (
                            <th className="fw-bold px-0">Style</th>
                        )}
                        {isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') && shouldShowVehicleColumn(refractedVehicleList, 'country') && (
                            <th className="fw-bold px-0">Country</th>
                        )}
                        {shouldShowVehicleColumn(refractedVehicleList, 'state_code') ? <th className="fw-bold px-0">State</th> : null}
                        {isPermissionExist(accessPermissions, 'Vin Number') && shouldShowVehicleColumn(refractedVehicleList, 'vehicle_number') && (
                            <th className="fw-bold px-0">VIN</th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {renderVehicleRow(refractedVehicleList?.[0], 0, refractedVehicleList)}
                </tbody>

                <tbody className="collapse" style={{ height: '300px' }} id='vehicleCollapse'>
                    {(refractedVehicleList?.slice(1) || []).map((v, i) => renderVehicleRow(v, i + 1, refractedVehicleList))}
                </tbody>
            </table>
        </div>
    }

    // Name on the card and billing zip for the gateway's card fields and CardConnect (as the card form:
    // name, card, expiry + CVV, zip)
    const cardNameField = (
        <div className="mb-3">
            <label htmlFor="name" className="form-label">Name on Card <span className='text-danger'> *</span></label>
            <input
                onChange={handleInputFieldsData}
                autoComplete="off"
                name='name'
                value={formData?.name || ''}
                className="form-control "
                maxLength={20}
                minLength={1}
                placeholder="Name on Card"
                type="text" />
            <span className="form-text text-danger h-40">{formError == 'pass' && !formData?.name ? 'This field is required' : ''}</span>
        </div>
    )
    const cardZipField = (
        <div className="mb-3">
            <label htmlFor="zip_code" className="form-label">Zip Code</label>
            <input
                onChange={handleInputFieldsData}
                className="form-control "
                maxLength="6"
                minLength="5"
                name="zip_code"
                value={formData?.zip_code || ''}
                pattern="[0-9]{5,6}"
                placeholder="Billing Address Zip Code"
                onKeyPress={(e) => isPermissionExist(accessPermissions, 'Allow AlfaNumericZipcode') ? restrictSpecialChar(e) : restrictInputValues(e)}
                type="text" />
            <span className="form-text text-danger h-40">**Mandatory for Amex Cards only</span>
        </div>
    )

    return (
        <div>
            <ModalTerm partnerDetails={partnerDetails} facilityId={formData?.facility_id} setShow={setTermShow} show={showTerm} />

            <h4 className="mb-4 text-center">Confirm Your Details</h4>
            <div className="card border-bottom-0">
                <div className="row g-0">
                    <div className="col">
                        <div className="card-header fw-bold">
                            Basic Information
                        </div>
                        <div className="card-body">
                            <p className="mb-1"><b>Name :</b>  {formData?.firstname} {formData?.lastname} </p>
                            <p className="mb-1"><b>Email :</b>  {formData?.email}</p>
                            <p className="mb-0"><b>Phone Number :</b> {formData?.phone ? phoneMasker(formData?.phone) : 'N/A'}</p>

                        </div>
                    </div>
                    {!isPermissionExist(accessPermissions, 'Driving License') ? <div className="col-sm-6 border-start">
                        <div className="card-header">
                            <div className="d-flex">
                                <div className="fw-bold">Driver License Number : </div>
                                <p className="m-0 align-items-end ms-auto"><span className="badge badgeColor">{formData?.resident}</span> {formData?.license_number}</p>
                            </div>

                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col text-center ">
                                    <b>Drivers License Proof (Front)</b>
                                    {images?.front ? <div className="border  p-1 text-center">
                                        <img height="46px" src={images?.front} />
                                    </div> : <div className="p-1 text-center">-</div>}
                                </div>
                                <div className="col text-center ">
                                    <b>Drivers License Proof (Back)</b>
                                    {images?.back ? <div className="border  p-1 text-center">
                                        <img height="46px" src={images?.back} />
                                    </div> : <div className="p-1 text-center">-</div>}
                                </div>
                            </div>
                        </div>
                    </div> : null}
                </div>


                <div className="border-top border-bottom container py-2">
                    <div className="d-flex align-items-center mb-2 justify-content-between">
                        <b>Vehicle(s)</b>
                        {refractedVehicleList?.length > 1 && (
                            <div className='d-flex gap-2'>
                                <span className='fw-bold text-primary'>
                                    {`${refractedVehicleList?.length} ${refractedVehicleList?.length > 1 ? 'Vehicles' : 'Vehicle'}`}
                                </span>
                                <button
                                    className='btn btn-outline-dark btn-sm'
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target='#vehicleCollapse'
                                    aria-expanded={displayVehicle}
                                    aria-controls='vehicleCollapse'
                                    onClick={handleshowVehicle}
                                >
                                    {displayVehicle ? 'Hide All' : 'View All'}
                                </button>
                            </div>
                        )}
                    </div>
                    {isMobile ? <div>
                        <div>
                            {mobileViewVehicleSection(refractedVehicleList?.[0], 0, refractedVehicleList)}
                        </div>

                        <div className="collapse" style={{ height: '300px' }} id='vehicleCollapse'>
                            {(refractedVehicleList?.slice(1) || []).map((v, i) => mobileViewVehicleSection(v, i + 1, refractedVehicleList))}
                        </div>
                    </div> : deskTopViewVehicleSection()}
                </div>
            </div>
            {formData?.driver?.length > 0 && <div className="  p-2 px-3  border border-top-0">
                {formData?.driver?.map((v, i) => {
                    return (
                        <div className='row ' key={i}>
                            <div className='col-sm-6'><b>Driver Name :</b> {v?.driver_name ? v?.driver_name : '-'}</div>
                            <div className='col-sm-6'>
                                <div className="d-flex align-items-center">
                                    <b> Document: &nbsp;</b>
                                    {v?.signature_name ? <div className='border'><img style={{ maxHeight: '100px', maxWidth: '200px' }} src={URL.createObjectURL(v?.driver_signature)} alt="Preview" /></div> : '-'}
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>}
            <div className="bg-white border p-3  my-2">
                <div className='row align-items-center' >
                    <div className='col-8'>
                        <h4 className="text-primary">{facility?.full_name}</h4>
                        <p className="m-0"><b>Entrance Address: </b>{`${facility?.geolocations?.address_1 ? facility?.geolocations?.address_1 : ''}${facility?.geolocations?.address_2 ? `, ${facility?.geolocations?.address_2}` : ''}${facility?.geolocations?.city ? `, ${facility?.geolocations?.city}` : ''}${facility?.geolocations?.state ? `, ${facility?.geolocations?.state}` : ''}${facility?.geolocations?.zip_code ? `, ${facility?.geolocations?.zip_code}` : ''}`}</p>
                        {((facility?.facility_configuration && facility?.facility_configuration?.is_prorate_apply == '0')) ? <div className='d-flex'>
                            <tr>
                                <th>
                                    Start Date
                                </th>
                                <td>:</td>
                                <td className='text-end'>
                                    <span>{prorateResponse?.start_date ? `${moment(prorateResponse?.start_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span>
                                </td>
                            </tr><tr className='ms-4'>
                                <th>
                                    End Date
                                </th>
                                <td>:</td>
                                <td className='text-end'>
                                    <span>{prorateResponse?.end_date ? `${moment(prorateResponse?.end_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span>
                                </td>
                            </tr>
                        </div> : ''
                        }
                        {selectedPermit?.permit_rate_criteria_mapping?.length > 0 ? perkingParkingTime(selectedPermit, true) : null}
                    </div>



                    <div className='row align-items-center' >

                        <div className='col-4'>
                            {/* {rateList?.permit_rate?.map((permitPricesItem, permitPricesIndex) => {
                            return (
                                <> */}
                            <div className=' p-2 '>
                                <input type="radio" className="btn-check" name="permit_rate" id={'btnradio1'} autoComplete="off" onClick={(e) => handleInputFieldsData(e, 1, selectedPermit)} checked />
                                {/* checked={(permitPricesItem?.id === formData?.permit_rate_id)} */}
                                <label className=" position-relative w-100 text-end" htmlFor={'btnradio1'}>
                                    {/* <h6 className="fw-bold mb-0 text-primary">Rates to start soon</h6> */}
                                    {/* <h2 className="fw-bold mb-0 text-primary">{selectedPermit?.rate ? `$${selectedPermit?.rate}` : ''}</h2> */}
                                    {/* <p className="mb-0 text-primary">{selectedPermit?.name}</p> */}
                                    {/* <span>{permitPricesIndex + 1}</span> */}
                                </label>
                            </div>

                            {/* </>
                            )
                        })} */}
                        </div>

                    </div>
                </div>

            </div>

            <div className="border mb-3 p-3">

                {/* {dynamic permit} */}


                {isPermissionExist(accessPermissions, 'Display Promocode') ? <div className="block">
                    <div className="row">
                        <div className="col-sm-6">

                            <label htmlFor="promocode" className="form-label">Promo Code</label>

                            <div className="input-group position-relative">
                                <input
                                    autoComplete="off"
                                    className="form-control "
                                    placeholder="Enter Promo Code"
                                    name="promocode"
                                    value={coupon}
                                    onChange={handleInputFieldsData}
                                    type="text"
                                    required=""
                                />
                                <button type="button" className="btn btn-primary d-flex" onClick={(e) => handleCouponCode(e)}>Apply  {isLoading ? <span className=' ms-2'><Circles
                                    height="20"
                                    width="20"
                                    color="#ffffff"
                                    ariaLabel="circles-loading"
                                    visible={true}
                                /></span> : null}
                                </button>
                                {couponRemoveButton && <span className="btn floatBtnCross" id="basic-addon1" onClick={handleCouponRemove}><i className='fa fa-times text-danger'></i></span>}
                            </div>
                        </div>


                        <div className='errorBlock d-inline-block'>{couponError == 'loading' ? <span className=' ms-2'><Circles
                            height="20"
                            width="20"
                            color="var(--bs-primary)"
                            ariaLabel="circles-loading"
                            visible={true}
                        /></span> : <small className='text-danger'>{couponError}</small>}
                        </div>



                    </div>

                </div> : null}
                {(!facility?.facility_configuration || (facility?.facility_configuration && facility?.facility_configuration?.is_prorate_apply != '0')) ? <div className="card ">
                    <div className="card-header">
                        <b> Purchase Summary</b>
                    </div>
                    {paymentLoader && coupon ? <span className='m-5 d-flex justify-content-center'><Circles
                        height="40"
                        width="40"
                        color="var(--bs-primary)"
                        ariaLabel="circles-loading"
                        visible={true}
                    /></span> : <div className="card-body">
                        <div className="row align-items-center g-5">
                            <div className="col-12 col-sm-6">
                                <table className="table table-sm table-borderless">
                                    <tbody><tr>
                                        <th>
                                            Price
                                        </th>
                                        <td>:</td>
                                        <td className='text-end'>
                                            <span>{prorateResponse?.effective_pro_rate ? `$${prorateResponse?.effective_pro_rate} (Prorated price)` : ''}</span>
                                        </td>
                                    </tr>
                                        {(prorateResponse?.processing_fee && prorateResponse?.processing_fee > 0) && <tr>
                                            <th>
                                                Processing Fee
                                            </th>
                                            <td>:</td>
                                            <td className='text-end'>
                                                <span>{(prorateResponse?.processing_fee && prorateResponse?.processing_fee > 0) ? `+ $${prorateResponse?.processing_fee}` : ''}</span>
                                            </td>
                                        </tr>}
                                        <tr>
                                            <th>
                                                Start Date
                                            </th>
                                            <td>:</td>
                                            <td className='text-end'>
                                                <span>{prorateResponse?.start_date ? `${moment(prorateResponse?.start_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span>
                                            </td>
                                        </tr><tr>
                                            <th>
                                                End Date
                                            </th>
                                            <td>:</td>
                                            <td className='text-end'>
                                                <span>{prorateResponse?.end_date ? `${moment(prorateResponse?.end_date, 'MM-DD-YYYY').format('MM/DD/YYYY')}` : ''}</span>
                                            </td>
                                        </tr>
                                        {(isCouponApplied && prorateResponse?.promocode_discount_amount) ?
                                            <tr>
                                                <th>
                                                    Promo Code Discount
                                                </th>
                                                <td>:</td>
                                                <td className='text-end'>
                                                    <span className="text-danger">{prorateResponse?.promocode_discount_amount ? `- $${prorateResponse?.promocode_discount_amount}` : ''}</span>
                                                </td>
                                            </tr> : ''}


                                    </tbody></table>


                            </div>

                            <div className="col text-end">

                                <h3 className="fw-bold m-0">Total : {prorateResponse?.total_amount ? `$${prorateResponse?.total_amount}` : ''}</h3>

                                {/* <h3 className="fw-bold m-0">Total : {prorateResponse?.total_amount ? `$${prorateResponse?.total_amount}` : ''}</h3> */}
                            </div>
                        </div>
                    </div>}
                </div> : ''}
                <div className={prorateResponse?.total_amount ? Number(prorateResponse?.total_amount) > 0 ? 'd-inline' : 'd-none' : 'd-none'}>
                    <div className="mt-4" id="accountExpand">
                        <b className="mt-0" style={{ fontSize: 'larger' }}>Card Details</b>
                        <hr className="my-1" />

                        {isLoggedIn() &&
                            <div className='row '>
                                {cardList?.length > 0 && <div className="col-sm-6">
                                    <div className="mb-3">
                                        <select name="vehicle" id="vehicle" disabled={isCardFormVisible} className="form-select" onChange={handleCardSelectChange} >
                                            <option>Select Card</option>
                                            {cardList?.map((card, index) => {
                                                return (
                                                    <option value={card?.payment_profile_id} selected={card?.payment_profile_id == formData?.payment_profile_id} key={index}>{`XXXX XXXX XXXX ${card?.card_last_four?.slice(0, 4) ? card?.card_last_four?.slice(0, 4) : 'XXXX'} (${card?.expiry?.slice(0, 2) ? card?.expiry?.slice(0, 2) : '-'}/${card?.expiry?.slice(2, 4) ? card?.expiry?.slice(2, 4) : '-'})`}</option>
                                                )
                                            })}
                                        </select>
                                        <span className="form-text text-danger h-40">{formError == 'pass' && !isCardFormVisible && (!formData?.payment_profile_id && !formData?.card_pan) ? 'Please select or add new card' : ''}</span>
                                    </div>
                                </div>}

                                {cardList?.length > 0 && !isCardFormVisible ? <div className='col-sm-6 mb-3'>{cardList?.length > 0 && <span className='badge badge-primary text-dark fw-bold me-2'>OR</span>}<button className='btn btn-primary' type="button" onClick={showCardForm}><i className='fa fa-plus'></i> Add New Card</button></div> : cardList?.length > 0 && <div className='col-sm-6 mb-3'><span className='badge badge-primary text-dark fw-bold me-2'>OR</span>  <button className='btn btn-danger' type="button" onClick={hideCardForm}>Select Existing Card</button></div>}

                            </div>}

                        {/* Fiserv: CardConnect iframe instead of the card form */}
                        {(cardList?.length < 1 || isCardFormVisible) && facility?.facility_payment_details?.facility_payment_type_id == PAYMENT_GATEWAY.FISERV && <>
                            {cardNameField}
                            <CardConnectTokenizer
                                setToken={setCardToken}
                                faciltyPaymentDetails={facility?.facility_payment_details}
                                setIframeErrorMessage={setIframeErrorMsg}
                                tokenRef={tokenRef}
                            />
                            {cardZipField}
                        </>}
                        {(cardList?.length < 1 || isCardFormVisible) && facility?.facility_payment_details?.facility_payment_type_id != PAYMENT_GATEWAY.FISERV && !usesHostedCardFields(facility) && <div>
                            <div className="row">
                                <div className="col-sm-6 ">
                                    <div className="mb-3">
                                        <label htmlFor="Name on Card" className="form-label">Name on Card <span className='text-danger'> *</span></label>
                                        <input
                                            onChange={handleInputFieldsData}
                                            autoComplete="off"
                                            name='name'
                                            className="form-control "
                                            maxLength={20}
                                            minLength={1}
                                            placeholder="Name on Card"
                                            type="text"
                                            required="" />
                                        <span className="form-text text-danger h-40">{formError == 'pass' && !formData?.name ? 'This field is required' : ''}</span>
                                    </div>
                                </div>

                                <div className="col-sm-6 col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="Card Number" className="form-label">Card Number <span className='text-danger'> *</span>
                                        </label>
                                        <MaskedInput
                                            maskGenerator={cardnumbermask}
                                            value={card}
                                            type="text"
                                            name="card_pan"
                                            id="card_pan"
                                            required={true}
                                            pattern="[0-9 ]{18,19}"
                                            maxLength='19'
                                            minLength='18'
                                            title="Card no. should be 15-16 digit numeric"
                                            className="form-control"
                                            onChange={handleCardChange}
                                            placeholder="Card Number"
                                        />
                                        <span className="form-text text-danger h-40">{formError == 'pass' ? !formData?.card_pan ? 'This field is required' : validateCardNumber(formData?.card_pan) ? '' : '' : ''}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 col-md-6">
                                    <div className="mb-3">
                                        <label htmlFor="Card Number" className="form-label">Card Expiry <span className='text-danger'> *</span>
                                        </label>
                                        <MaskedInput
                                            maskGenerator={expirymask}
                                            value={expiry}
                                            type="text"
                                            autoComplete="off"
                                            name="expiration_date"
                                            id="expiration_date"
                                            required={true}
                                            pattern="[0-9 ]{4}"
                                            maxLength='5'
                                            minLength='4'
                                            title="Enter a valid expiry date"
                                            className="form-control"
                                            onChange={handleExpiryChange}
                                            onInvalid={e => e.target.setCustomValidity('Please enter a valid expiry date')}
                                            onInput={e => e.target.setCustomValidity('')}
                                            placeholder="MM/YY"
                                        />

                                        <span className="form-text text-danger h-40">{formError == 'pass' ? !formData?.expiration_date ? 'This field is required' : '' : ''}</span>
                                        <span className="form-text text-danger h-40">{formError == 'pass' ? formData?.expiration_date && (formData?.expiration_date?.length < 4 || formData?.expiration_date?.length > 5) ? 'Enter a valid expiry date ' : '' : ''}</span>

                                    </div> </div>

                                <div className="col-sm-6">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label">CVV <span className='text-danger'> *</span></label>
                                        <input
                                            onChange={handleInputFieldsData}
                                            autoComplete="off"
                                            className="form-control"
                                            id="standardCardCvv"
                                            maxLength="4"
                                            name="card_card_security_cvx_2"
                                            placeholder="CVV / Security Code"
                                            type="password"
                                            onKeyPress={(e) => restrictInputValues(e)}

                                            required=""
                                        />
                                        <span className="form-text text-danger h-40">{formError == 'pass' && !formData?.card_card_security_cvx_2 ? 'This field is required' : ''}</span>
                                    </div>
                                </div></div>
                            <div className="row">

                                <div className="col-sm-4">
                                    <div className="mb-3">
                                        <label htmlFor="" className="form-label">Zip Code <span className='text-danger'> *</span></label>
                                        <input
                                            onChange={handleInputFieldsData}
                                            className="form-control "
                                            maxLength="6"
                                            minLength="5"
                                            name="zip_code"
                                            pattern="[0-9]{5,6}"
                                            placeholder="Billing Address Zip Code"
                                            type="text"
                                            required=""
                                        />
                                        <span className="form-text text-danger h-40">{formError == 'pass' && !formData?.zip_code ? 'This field is required' : ''}</span>
                                    </div>
                                </div>
                            </div>

                            <input type='hidden' name='XXX_IPG_XXX' id='XXX_IPG_XXX' value='confirm' />
                            <input type='hidden' name='XXX_IPGTRXNO_XXX' id='XXX_IPGTRXNO_XXX' value={guidValue} />
                            <input type='hidden' name='XXX_IPGSESSION_XXX' id='XXX_IPGSESSION_XXX' value={resValue}></input>
                        </div>
                        }
                    </div>
                    <div className=' my-2' >
                        <div className="form-check">
                            <input disabled={Number(formData?.permit_final_amount) <= 0 ? true : false} className="form-check-input" type="checkbox" id="userConsent" name="userConsent" onClick={(e) => handleConsentChange(e)} checked={isConsent} />
                            <small>By clicking this button, you are providing your consent for auto renewal of the permit if approved.</small>
                        </div>
                    </div>
                </div>
            </div>
            <div className='border p-3 my-2' >
                <div className="row">
                    <div className="col-sm-6 ">
                        <div className="mb-4">
                            <label htmlFor="Remark" className="form-label">Remarks </label>
                            <input
                                onChange={handleInputFieldsData}
                                autoComplete="off"
                                name='user_remark'
                                className="form-control "
                                maxLength={100}
                                placeholder="Remarks"
                                type="text"
                            />
                        </div>
                    </div>
                </div>
                <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="userAcknowledge" name="userAcknowledge" required onClick={(e) => handleAcknowledge(e)} checked={formData?.userAcknowledge} />
                    <small>I have read and agreed to the {partnerDetails?.term_condition_heading ? partnerDetails?.term_condition_heading : 'ParkEngage'} <a href='javascript:;' onClick={handleModalTerm}>Terms & Conditions</a>.</small>
                    <span className="form-text text-danger h-40 d-block">{formError == 'pass' && !formData?.userAcknowledge ? 'Please provide your acknowledgement on above Terms and Conditions.' : ''}</span>

                </div>
            </div>
            {/* New card in the gateway's hosted fields (Stripe, Datacap / Heartland iframe), with their own Submit */}
            {showsHostedCardFields && <div className='my-2'>
                {cardNameField}
                <PaymentGatewayCommon
                    faciltyData={facility}
                    onSubmit={onCardSubmit}
                    setIsSubmittingForm={() => {}}
                    isSubmittingForm={isSubmitting}
                    previousButton={<></>}
                    setFormData={setFormData}
                    formData={formData}
                    setValue={() => {}}
                    customGateWay={<></>}
                    page='permitRequestForm'
                    amount={prorateResponse?.total_amount || formData?.permit_rate || 0}
                    // Permit request: the card is verified and saved now, charged at approval
                    stripeIntentMode='setup'
                    // Billing zip after the card fields, before the gateway's Submit
                    consent={cardZipField}
                />
            </div>}
        </div>
    )
}

Pass.propTypes = {
    onCardSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    setHostedCardShown: PropTypes.func,
    setCardToken: PropTypes.func,
    setIframeErrorMsg: PropTypes.func,
    tokenRef: PropTypes.object,
    dispatch: PropTypes.func,
    data: PropTypes.object,
    events: PropTypes.object,
    loader: PropTypes.bool,
    getCard: PropTypes.func,
    passData: EMPTY_ARRAY,
    setPage: PropTypes.string,
    idProof: PropTypes.object,
    rateList: PropTypes.object,
    paymentLoader: PropTypes.bool,
    formData: PropTypes.object,
    setFormData: PropTypes.func,
    formError: PropTypes.string,
    guidValue: PropTypes.string,
    resValue: PropTypes.string,
    partnerDetails: PropTypes.object,
    notify: PropTypes.func,
    selectedVehicleList: PropTypes.array
}

Pass.defaulProps = {
    dispatch: noop,
    data: EMPTY_OBJECT,
    events: EMPTY_OBJECT,
    loader: PropTypes.bool,
    getCard: PropTypes.func,
    passData: EMPTY_ARRAY,
    setPage: undefined,
    idProof: EMPTY_OBJECT,
    rateList: EMPTY_OBJECT,
    paymentLoader: false,
    formData: EMPTY_OBJECT,
    setFormData: noop,
    formError: undefined,
    guidValue: '',
    resValue: '',
    partnerDetails: EMPTY_OBJECT,
    notify: noop,
    selectedVehicleList: EMPTY_ARRAY
}

function mapStateToProps({ paymentReducer, basicInfoReducer, PartnerReducer }) {
    return {
        data: paymentReducer,
        paymentLoader: paymentReducer?.proRateLoader,
        rateList: basicInfoReducer.rateList.data,
        partnerDetails: PartnerReducer?.partnerDetails?.data,
    }
}
export default connect(mapStateToProps)(Pass)